// Villas missing the requested language fall back to English, then Italian
const VILLA_TRANSLATION_FALLBACK_LOCALES: readonly Locale[] = ['en', 'it'];

export default function translateFromArray<T extends { locale: string }>({
  lang,
  translations,
  fallbackLocales = [],
}: {
  lang: string;
  translations: Array<T>;
  fallbackLocales?: readonly Locale[];
}): T | undefined {
  for (const locale of [lang, ...fallbackLocales]) {
    const translation = translations?.find((item) => item.locale === locale);

    if (translation) return translation;
  }

  return undefined;
}

// Last resort is any available translation, so a villa page never renders without text
export function getVillaTranslation<T extends { locale: string }>({
  lang,
  translations,
}: {
  lang: string;
  translations: Array<T>;
}): T | undefined {
  return (
    translateFromArray({
      lang,
      translations,
      fallbackLocales: VILLA_TRANSLATION_FALLBACK_LOCALES,
    }) ?? translations?.[0]
  );
}
